<!-- MOBILE OVERLAY -->
@if (isOpen) {
<div class="fixed inset-0 bg-black/40 z-40 lg:hidden" (click)="sidebarService.close()"></div>
}

<!-- SIDEBAR -->
<aside
  class="fixed inset-y-0 start-0 w-[300px] md:w-[280px] bg-primary text-white flex flex-col z-[99999] transform transition-transform duration-300 -translate-x-full lg:translate-x-0"
  [class.translate-x-0]="isOpen" [class.sidebar-closed]="!isOpen">
  <!-- SCROLLABLE -->
  <div class="flex-1 overflow-y-auto px-2 py-4 sidebar-scroll">
    <!-- LOGO -->
    <div class="flex items-center justify-center gap-3 mb-4 px-1">
      <img src="images/loanly-white.png" class="h-10" />

      <span class="text-2xl font-bold text-white"> Loanly </span>
    </div>

    <!-- MENU -->
    <nav class="space-y-2">
      <!-- DASHBOARD -->
      <a routerLink="/dashboard" routerLinkActive="bg-indigo-700" [routerLinkActiveOptions]="{ exact: true }"
        (click)="sidebarService.close()"
        class="flex items-center gap-4 px-6 py-4 rounded-2xl hover:bg-indigo-700 transition-all">
        <img src="/images/dashboard.png" class="h-5" />

        <span>{{ 'SIDEBAR.DASHBOARD' | translate }}</span>
      </a>

      <!-- LEADS -->
      <a *ngIf="hasAccess('/leads')" routerLink="/leads" routerLinkActive="bg-indigo-700"
        (click)="sidebarService.close()"
        class="flex items-center gap-4 px-6 py-4 rounded-2xl hover:bg-indigo-700 transition-all">
        <img src="/images/customer.png" class="h-5" />

        <span>{{ 'SIDEBAR.LEADS' | translate }}</span>
      </a>

      <!-- ONBOARDING -->
      <a *ngIf="hasAccess('/onboard')" routerLink="/onboard" routerLinkActive="bg-indigo-700"
        (click)="sidebarService.close()"
        class="flex items-center gap-4 px-6 py-4 rounded-2xl hover:bg-indigo-700 transition-all">
        <img src="/images/corprate.png" class="h-5" />

        <span>{{ 'SIDEBAR.ONBOARDING' | translate }}</span>
      </a>
      <!-- CREDIT -->
      <div>
        <!-- CREDIT PARENT -->
        <a class="flex items-center justify-between px-6 py-4 rounded-2xl cursor-pointer hover:bg-indigo-700 transition-all"
          (click)="toggleCredit()">
          <div class="flex items-center gap-4">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M3 7h18M5 7v10a2 2 0 002 2h10a2 2 0 002-2V7M8 11h8" />
            </svg>

            <span>{{ 'SIDEBAR.CREDIT' | translate }}</span>
          </div>

          <svg class="h-4 w-4 transition-transform duration-300" [class.rotate-180]="isCreditOpen" fill="none"
            stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </a>

        <!-- CREDIT CHILD -->
        <div *ngIf="isCreditOpen" class="ms-8 space-y-1">
          <a *ngIf="hasAccess('/credit')" routerLink="/cradit-list" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.CREDIT_LIST' | translate }}
          </a>
        </div>
      </div>

      <!-- MONITORING -->
      <div>
        <!-- MONITORING PARENT -->
        <a class="flex items-center justify-between px-6 py-4 rounded-2xl cursor-pointer hover:bg-indigo-700 transition-all"
          (click)="toggleMonitoring()">
          <div class="flex items-center gap-4">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 3v16a2 2 0 002 2h16M7 15l3.5-4 3 3L20 7" />
            </svg>

            <span>{{ 'SIDEBAR.MONITORING' | translate }}</span>
          </div>

          <svg class="h-4 w-4 transition-transform duration-300" [class.rotate-180]="isMonitoringOpen" fill="none"
            stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </a>

        <!-- MONITORING CHILD -->
        <div *ngIf="isMonitoringOpen" class="ms-8 space-y-1">
          <a routerLink="/monitoring" routerLinkActive="bg-indigo-600" [routerLinkActiveOptions]="{ exact: true }"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.MONITORING_LIST' | translate }}
          </a>
        </div>
      </div>

      <!-- FACILITY OFFER LETTER -->
      <a *ngIf="hasAccess('/facilites')" routerLink="/facilites" routerLinkActive="bg-indigo-700"
        (click)="sidebarService.close()"
        class="flex items-center gap-4 px-6 py-4 rounded-2xl hover:bg-indigo-700 transition-all">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M3 21h18v-2H3v2zm2-4h4V3H5v14zm6 0h8V7h-8v10zm2-8h2v2h-2V9zm0 4h2v2h-2v-2zM7 5h2v2H7V5zm0 4h2v2H7V9zm0 4h2v2H7v-2z" />
        </svg>

        <span>{{ 'SIDEBAR.FACILITY_OFFER_LETTER' | translate }}</span>
      </a>

      <a *ngIf="hasAccess('/client')" routerLink="/client-list" routerLinkActive="bg-indigo-700"
        (click)="sidebarService.close()"
        class="flex items-center gap-4 px-6 py-4 rounded-2xl hover:bg-indigo-700 transition-all">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M16 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
          <circle cx="10" cy="7" r="4" stroke-linecap="round" stroke-linejoin="round" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M20 8v6M17 11h6" />
        </svg>

        <span>{{ 'SIDEBAR.CLIENLIST' | translate }}</span>
      </a>

      <!-- DISBURSEMENT -->
      <div>
        <!-- DISBURSEMENT PARENT -->
        <a class="flex items-center justify-between px-6 py-4 rounded-2xl cursor-pointer hover:bg-indigo-700 transition-all"
          (click)="toggleDisbursement()">
          <div class="flex items-center gap-4">
            <img src="/images/disbursement.png" class="h-6" />

            <span>{{ 'SIDEBAR.DISBURSEMENT' | translate }}</span>
          </div>

          <svg class="h-4 w-4 transition-transform duration-300" [class.rotate-180]="isDisbursementOpen" fill="none"
            stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </a>

        <!-- DISBURSEMENT CHILD -->
        <div *ngIf="isDisbursementOpen" class="ms-8 space-y-1">
          <a *ngIf="hasAccess('/disbursement')" routerLink="/disbursement" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.DISBURSEMENT_LIST' | translate }}
          </a>

          <a routerLink="/proposed-disbursement" routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.PROPOSED_DISBURSEMENT' | translate }}
          </a>
        </div>
      </div>

      <!-- REPORTS -->
      <div *ngIf="
          hasAnyAccess([
            '/reports/disbursement',
            '/reports/repayment',
            '/reports/qpr',
            '/reports/qpr-listing',
            '/reports/mpr',
            '/reports/mpr-listing',
            '/reports/exposure',
            '/reports/approved-facilities',
            '/reports/projection',
            '/reports/enhanced-approved-facilities',
            '/reports/consolidated-qpr',
            '/reports/pb-consolidated-qpr',
            '/reports/consolidated-mpr',
          ])
        ">
        <!-- REPORTS PARENT -->
        <a class="flex items-center justify-between px-6 py-4 rounded-2xl cursor-pointer hover:bg-indigo-700 transition-all"
          (click)="toggleReports()">
          <div class="flex items-center gap-4">
            <img src="/images/reports.png" class="h-6 brightness-0 invert" />

            <span>{{ 'SIDEBAR.REPORTS' | translate }}</span>
          </div>

          <svg class="h-4 w-4 transition-transform duration-300" [class.rotate-180]="isReportsOpen" fill="none"
            stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </a>

        <!-- REPORTS CHILD -->
        <div *ngIf="isReportsOpen" class="ms-8 space-y-1">
          <a *ngIf="hasAccess('/reports/disbursement')" routerLink="/reports/disbursement"
            routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.DISBURSEMENT_REPORT' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/repayment')" routerLink="/reports/repayment" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.REPAYMENT_REPORT' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/qpr')" routerLink="/reports/qpr" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.QPR_REPORT' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/qpr-listing')" routerLink="/reports/qpr-listing"
            routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.QPR_LISTING' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/mpr')" routerLink="/reports/mpr" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.MPR_REPORT' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/mpr-listing')" routerLink="/reports/mpr-listing"
            routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.MPR_LISTING' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/exposure')" routerLink="/reports/exposure" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.EXPOSURE_REPORT' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/approved-facilities')" routerLink="/reports/approved-facilities"
            routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.APPROVED_FACILITIES_REPORT' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/projection')" routerLink="/reports/projection" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.PROJECTION_REPORT' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/enhanced-approved-facilities')"
            routerLink="/reports/enhanced-approved-facilities" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.ENHANCED_APPROVED_FACILITIES_REPORT' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/consolidated-qpr')" routerLink="/reports/consolidated-qpr"
            routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.CONSOLIDATED_QPR_REPORT' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/pb-consolidated-qpr')" routerLink="/reports/pb-consolidated-qpr"
            routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.PB_CONSOLIDATED_QPR_REPORT' | translate }}
          </a>

          <a *ngIf="hasAccess('/reports/consolidated-mpr')" routerLink="/reports/consolidated-mpr"
            routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.CONSOLIDATED_MPR_REPORT' | translate }}
          </a>
        </div>
      </div>

      <!-- ADMIN -->
      <div *ngIf="hasAnyAccess(['/general-voucher', '/role-assignment', '/user-management'])">
        <!-- ADMIN PARENT -->
        <a class="flex items-center justify-between px-6 py-4 rounded-2xl cursor-pointer hover:bg-indigo-700 transition-all"
          (click)="toggleAdmin()">
          <div class="flex items-center gap-4">
            <img src="/images/admin.png" class="h-6" />

            <span>{{ 'SIDEBAR.ADMIN' | translate }}</span>
          </div>

          <svg class="h-4 w-4 transition-transform duration-300" [class.rotate-180]="isAdminOpen" fill="none"
            stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </a>

        <!-- ADMIN CHILD -->
        <div *ngIf="isAdminOpen" class="ms-8 space-y-1">
          <a *ngIf="hasAccess('/general-voucher')" routerLink="/general-voucher" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.GENERAL_VOUCHER' | translate }}
          </a>
        </div>
      </div>

      <!-- CNIC EXPIRY -->
      <a *ngIf="canSeeCnicExpiry" routerLink="/cnic-expiry" routerLinkActive="bg-indigo-700"
        (click)="sidebarService.close()"
        class="flex items-center gap-4 px-6 py-4 rounded-2xl hover:bg-indigo-700 transition-all">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M3 7a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7zM14 10h4M14 14h4M8.5 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM6 15.5a2.5 2.5 0 015 0" />
        </svg>

        <span>{{ 'SIDEBAR.CNIC_EXPIRY' | translate }}</span>
      </a>

      <!-- SETUP -->
      <div *ngIf="
          hasAnyAccess([
            '/common-codes',
            '/guarantor-setup',
            '/usd-rate-list',
            '/kibor',
            '/city',
            '/geography',
            '/questioner',
            '/document-setup',
            '/client-gl-code',
            '/payment-type',
            '/user-management',
            '/employee-registration',
            '/department-head',
          ])
        ">
        <!-- SETUP PARENT -->
        <a class="flex items-center justify-between px-6 py-4 rounded-2xl cursor-pointer hover:bg-indigo-700 transition-all"
          (click)="toggleSetup()">
          <div class="flex items-center gap-4">
            <img src="/images/setup.png" class="h-6" />

            <span>{{ 'SIDEBAR.SETUP' | translate }}</span>
          </div>

          <svg class="h-4 w-4 transition-transform duration-300" [class.rotate-180]="isSetupOpen" fill="none"
            stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </a>

        <!-- SETUP CHILD -->
        <div *ngIf="isSetupOpen" class="ms-8 space-y-1">
          <a *ngIf="hasAccess('/common-codes')" routerLink="/common-codes" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.COMMON_CODES' | translate }}
          </a>
          @if (hasAccess('/guarantor-setup')) {
            <a routerLink="/guarantor-setup" routerLinkActive="bg-indigo-600"
              (click)="sidebarService.close()"
              class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
              {{ 'SIDEBAR.GUARANTOR_SETUP' | translate }}
            </a>
          }
          @if (hasAccess('/usd-rate-list')) {
            <a routerLink="/usd-rate-list" routerLinkActive="bg-indigo-600"
              (click)="sidebarService.close()"
              class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
              {{ 'SIDEBAR.USD_RATE_LIST' | translate }}
            </a>
          }
          <a *ngIf="hasAccess('/user-management')" routerLink="/user-management" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.USER_MANAGEMENT' | translate }}
          </a>

          <a *ngIf="hasAccess('/kibor')" routerLink="/kibor" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.KIBOR' | translate }}
          </a>

          <a *ngIf="hasAccess('/city')" routerLink="/city" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.CITY' | translate }}
          </a>
          <a *ngIf="hasAccess('/department-head')" routerLink="/department-head" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.ORGANIZATION' | translate }}
          </a>
          <a *ngIf="hasAccess('/employee-registration')" routerLink="/employee-registration"
            routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.EMPLOYEE_REGISTRATION' | translate }}
          </a>
          <a *ngIf="hasAccess('/geography')" routerLink="/geography" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.GEOGRAPHY' | translate }}
          </a>

          <a *ngIf="hasAccess('/questioner')" routerLink="/questioner" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.QUESTIONER' | translate }}
          </a>
          <a routerLink="/financial" routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'LAYOUT.FINANCIAL_DATA' | translate }}
          </a>
          <a routerLink="/income-statement-type" routerLinkActive="bg-indigo-600" (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.INCOME_STATEMENT_TYPE' | translate }}
          </a>


          <a *ngIf="hasAccess('/document-setup')" routerLink="/document-setup" routerLinkActive="bg-indigo-600"
            (click)="sidebarService.close()"
            class="block px-5 py-3 rounded-xl text-sm hover:bg-indigo-700 transition-all">
            {{ 'SIDEBAR.DOCUMENT_SETUP' | translate }}
          </a>

          <!-- GL -->
          <div *ngIf="hasAnyAccess(['/client-gl-code', '/payment-type'])">
            <!-- GL PARENT -->
            <a class="flex items-center justify-between px-5 py-3 rounded-xl text-sm cursor-pointer hover:bg-indigo-700 transition-all"
              (click)="isGLOpen = !isGLOpen">
              <span>{{ 'SIDEBAR.GL' | translate }}</span>

              <svg class="h-4 w-4 transition-transform duration-300" [class.rotate-180]="isGLOpen" fill="none"
                stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </a>

            <!-- GL CHILD -->
            <div *ngIf="isGLOpen" class="ms-6 space-y-1">
              <a *ngIf="hasAccess('/client-gl-code')" routerLink="/client-gl-code" routerLinkActive="bg-indigo-600"
                (click)="sidebarService.close()"
                class="block px-5 py-2 rounded-xl text-xs hover:bg-indigo-700 transition-all">
                {{ 'SIDEBAR.CLIENT_GL_CODE' | translate }}
              </a>

              <a *ngIf="hasAccess('/payment-type')" routerLink="/payment-type" routerLinkActive="bg-indigo-600"
                (click)="sidebarService.close()"
                class="block px-5 py-2 rounded-xl text-xs hover:bg-indigo-700 transition-all">
                {{ 'SIDEBAR.PAYMENT_TYPE' | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <a class="flex items-center gap-4 px-6 py-4 cursor-pointer hover:text-indigo-300 transition-all"
        *ngIf="hasAccess('/notifications')" routerLink="/notifications" routerLinkActive="text-indigo-300">
        <!-- NOTIFICATION ICON -->
        <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11
         a6.002 6.002 0 00-4-5.659V5
         a2 2 0 10-4 0v0.341C7.67 6.165 6 8.388 6 11v3.159
         c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1
         a3 3 0 11-6 0v-1m6 0H9" />
        </svg>

        <span>
          {{ 'SIDEBAR.NOTIFICATIONS' | translate }}
        </span>
      </a>
      <!-- LOGOUT -->
      <a class="flex items-center gap-4 px-6 py-4 cursor-pointer hover:text-indigo-300 transition-all"
        (click)="logout()">
        <img src="/images/Signout.png" class="h-6" />

        <span>{{ 'SIDEBAR.SIGN_OUT' | translate }}</span>
      </a>
    </nav>
  </div>
</aside>